import { WalletProviderEnum } from '@dynamic-labs/sdk-api-core';

import type { DynamicClient } from '../../../client/types/DynamicClient';
import type { Chain } from '../../chain';
import { getWalletProviders } from '../../wallets/getWalletProviders';
import { formatWalletProviderKey } from '../../wallets/utils/formatWalletProviderKey';
import { DYNAMIC_WAAS_METADATA } from '../constants';
import { isWaasWalletProvider } from '../isWaasWalletProvider';
import type { WaasWalletProvider } from '../waas.types';

type FindWaasWalletProviderByChainParams = {
  chain: Chain;
};

export const findWaasWalletProviderByChain = (
  { chain }: FindWaasWalletProviderByChainParams,
  client: DynamicClient
): WaasWalletProvider | null => {
  const providers = getWalletProviders(client);

  const waasProviderKey = formatWalletProviderKey({
    chain,
    displayName: DYNAMIC_WAAS_METADATA.displayName,
    walletProviderType: WalletProviderEnum.EmbeddedWallet,
  });

  const waasProvider = providers.find(
    (provider) => provider.key === waasProviderKey && provider.chain === chain
  );

  if (!waasProvider || !isWaasWalletProvider(waasProvider)) {
    return null;
  }

  return waasProvider;
};
